var divider_viewer_rtlignore_default = {
  "divider-container": "Kj3hR",
  "divider-container--double": "-bYb6",
  "divider": "BolnJ",
  "divider--single": "xmS4N",
  "divider--double": "WJHs0",
  "divider--dashed": "UjYF3",
  "divider--dotted": "TzdiK",
  "divider--small": "wS-C7",
  "divider--medium": "kFfVY",
  "divider--large": "YoOgA",
  "divider--left": "_2IzDB",
  "divider--center": "_8qMOx",
  "divider--right": "U1lvG",
  "svgFixerContainer": "TwvX0",
  "emptyChar": "puCJR"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
